<div class="close-icon" mat-button (click)="dialogRef.close()"></div>

<mat-dialog-content style="margin-top: 40px;">
  <div style="display: flex; flex-direction: row;">
    <div style="flex:50%">
      <mat-form-field style="width: 100%">
        <mat-label>Name</mat-label>
        <input matInput

               [(ngModel)]="list.name"
               required
        >
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="save()" style="border-radius: 6px;">Save</button>
    <button mat-raised-button style="border-radius: 6px;" (click)="close()">Cancel</button>
  </div>
</mat-dialog-content>
